import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { styled } from "@mui/material/styles";
import { Outlet, useLocation } from "react-router-dom";
import { useMedia } from "react-use";
import Header from "../Header/index";
import ScrollToTopButton from "../ScrollToTopButton";

const ClippedDrawer = React.memo((props) => {
  const showMobileDrawer = useMedia("(max-width: 600px)");
  const [outletLoaded, setOutletLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setOutletLoaded(true);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const Main = styled("main")(({ theme }) => ({
    flexGrow: 1,
    height: "calc(100vh - 64px)", // Full height minus header
    overflowY: "auto", // Scrollbar only on content
    overflowX: "hidden",
    padding: theme.spacing(3),
    width: "100%",
    boxSizing: "border-box",
    position: "relative",
  }));
  
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%", overflow: "hidden" }}>
      {/* Fixed Header */}
      <Header
        handleDrawerToggle={props.handleDrawerToggle}
        hideSideBar={props.hideSideBar}
        showMobileDrawer={showMobileDrawer}
        isDarkTheme={props.isDarkTheme}
      />

      {/* Scrollable Body Content */}
      <Box sx={{ flexGrow: 1, width: "100%", overflow: "hidden", marginTop: "64px" }}>
        <CssBaseline />
        <Main>
          {location.pathname === "/" && (
            <div className="content_divider_ecllips"></div>
          )}
          {outletLoaded && <Outlet />}
          <ScrollToTopButton />
        </Main>
      </Box>
    </Box>
  );
});

export default ClippedDrawer;
